import type {
  MessageContent,
  MatchData,
  OddsData,
  OddsRecommendData,
  LeftSportCountData,
  TopSportCountData,
} from './proto/notification';

export enum EventEnum {
  match = 'match',
  odds = 'odds',
  odds_recommend = 'odds_recommend',
  left_sport_count = 'left_sport_count',
  top_sport_count = 'top_sport_count',
  notification_msg_route = 'notification_msg_route',
  balance_change_event = 'balance_change_event',
  bz_vip = 'bz_vip',
  odds_handover = 'odds_handover',
}

// 基础事件类型
export type Event = keyof typeof EventEnum;

// 基础消息结构 - 所有消息都必须包含这些字段
type BaseBusinessMessage<Type extends Event, Data, ExtentData> = {
  type: Type;
  data: Data;
  timestamp: number;
} & ExtentData;

export type MatchMessage = BaseBusinessMessage<
  EventEnum.match,
  MatchData,
  {
    matchId: MatchData['id'];
  }
>;

export type OddsMessage = BaseBusinessMessage<
  EventEnum.odds,
  OddsData,
  {
    code: OddsData['code'];
    matchId: MatchData['id'];
    marketId: string;
    specifiers: string;
  }
>;

export type OddsRecommendMessage = BaseBusinessMessage<EventEnum.odds_recommend, OddsRecommendData, {}>;

export type OddsHandoverMessage = BaseBusinessMessage<EventEnum.odds_handover, any, { matchId: MatchData['id'] }>;

export type LeftSportCountMessage = BaseBusinessMessage<EventEnum.left_sport_count, LeftSportCountData, {}>;

export type TopSportCountMessage = BaseBusinessMessage<EventEnum.top_sport_count, TopSportCountData, {}>;

export type InsiteMessageInfo = BaseBusinessMessage<EventEnum.notification_msg_route, Record<string, any>, {}>;

export type BalanceChangeInfo = BaseBusinessMessage<EventEnum.balance_change_event, MessageContent, {}>;

export type BzVipMessage = BaseBusinessMessage<EventEnum.bz_vip, Record<string, unknown>, {}>;

export type BusinessMessage =
  | MatchMessage
  | OddsMessage
  | OddsRecommendMessage
  | OddsHandoverMessage
  | LeftSportCountMessage
  | TopSportCountMessage
  | InsiteMessageInfo
  | BalanceChangeInfo
  | BzVipMessage;

export enum OperationType {
  /** Recharge / Deposit */
  RECHARGE = 'RECHARGE',
  /** Withdraw */
  WITHDRAW = 'WITHDRAW',
  /** Transfer */
  TRANSFER = 'TRANSFER',
  /** Payment */
  PAYMENT = 'PAYMENT',
  /** Refund */
  REFUND = 'REFUND',
  /** Exchange */
  EXCHANGE = 'EXCHANGE',
  /** Enable Credit */
  ENABLE_CREDIT = 'ENABLE_CREDIT',
  /** Adjust Credit Limit */
  ADJUST_CREDIT = 'ADJUST_CREDIT',
}

export type BalanceChangeData = {
  currency: string; // 例如: "INR"
  amount: string; // 注意：图片中金额是字符串格式 "50.00"
  operationType: OperationType;
};

export type BalanceChangeEvent = {
  type: 'balance_change_event';
  data: BalanceChangeData;
};
